import React from 'react';

import styles from './Row.scss';

type RowProps = {
  children: React.ReactNode;
  spacing?: number;
  wrappable?: boolean;
};

function Row(props: RowProps) {
  const { children, spacing = 0 } = props;

  return (
    <div className={styles.row}>
      {React.Children.map(children, (child, index) => {
        if (!child) return null;
        if (index === 0) return child;
        return (
          <div key={index} style={{ marginLeft: spacing }}>
            {child}
          </div>
        );
      })}
    </div>
  );
}

export default React.memo(Row);
